import React from 'react';

import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';

export default function Copyright(props)
{
  return (
    <Typography variant="body2" align="center" {...props}>
      <TermsOfUse />{' '}<PrivacyPolicy /><br/>
      &copy;2021-2024{' '}
      <Link color="inherit" href="https://uts-corp.co.jp/">
        Unitech System Co., Ltd.
      </Link>
    </Typography>
  );
}